import { render, staticRenderFns } from "./objPolygonSelected.vue?vue&type=template&id=952991c2&"
import script from "./objPolygonSelected.vue?vue&type=script&lang=ts&"
export * from "./objPolygonSelected.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports